import "../../css/customerQuoteRequests.css";
import Util from "../helpers/util";
import GoogleMapsApi from "../helpers/GoogleMapsApi";
import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";
var UtilObject = new Util();
var GoogleMapsApiObject = new GoogleMapsApi();

/**
 * Customer Quote Requests Component
 * Handles the customer-side quote request lifecycle.
 */
export default class customerQuoteRequests {
  constructor() {
    console.log("Customer Quote Requests — Loaded");
    this.customerId = null;
    this.init();
    this.bindEvents();
    window.customerQuoteRequestsObj = this;
  }

  init = () => {
    var allCookies = UtilObject.getAllCookies();
    this.customerId = allCookies.CUSTOMER_ID;

    this.loadCategories();
    this.checkPendingQuote();

    if (!this.customerId) {
      console.warn("Customer not logged in - viewing limited");
      return;
    }

    this.loadAddresses();
    this.loadMyRequests();
    this.loadNotificationBadge();
  };

  bindEvents = () => {
    // Tabs
    $(".cqr-tab")
      .off("click")
      .on("click", (e) => this.switchTab(e));

    // Create request
    $(".cqr-create-btn")
      .off("click")
      .on("click", () => {
        this.safeShowModal("createQuoteRequestModal");
      });
    $(".cqr-submit-request")
      .off("click")
      .on("click", () => this.createQuoteRequest());

    // Back to requests from quotes panel
    $(".cqr-back-to-requests")
      .off("click")
      .on("click", () => this.showRequestsList());

    // Map trigger
    $(".cqr-map-trigger")
      .off("click")
      .on("click", () => this.initMapSelection());

    // Address select change
    $("#cqrAddressSelect")
      .off("change")
      .on("change", (e) => {
        if ($(e.currentTarget).val() === "NEW") {
          $("#cqrNewAddressContainer").removeClass("d-none");
        } else {
          $("#cqrNewAddressContainer").addClass("d-none");
        }
      });

    // Mark all notifications read
    $(".cqr-mark-all-read")
      .off("click")
      .on("click", () => this.markAllNotificationsRead());

    // Bind Confirmation
    $(".cqr-confirm-bind")
      .off("click")
      .on("click", () => this.confirmBindQuote());

    // Guest login prompt confirm
    $(".cqr-guest-login-confirm")
      .off("click")
      .on("click", () => this.redirectToLoginAfterSavingData());

    // Image preview
    $("#cqrImage")
      .off("change")
      .on("change", (e) => this.handleImagePreview(e));
    $("#cqrRemoveImage")
      .off("click")
      .on("click", (e) => {
        e.stopPropagation();
        this.removeImagePreview();
      });
    $("#cqrImagePlaceholder")
      .off("click")
      .on("click", () => $("#cqrImage").click());
  };

  // =========================================================================
  // TABS
  // =========================================================================

  switchTab = (e) => {
    const tab = $(e.currentTarget).data("tab");
    $(".cqr-tab").removeClass("active");
    $(e.currentTarget).addClass("active");
    $(".cqr-tab-content").addClass("d-none");
    $(".cqr-quotes-panel").addClass("d-none");

    if (tab === "requests") {
      $(".cqr-requests-content").removeClass("d-none");
      this.loadMyRequests();
    } else if (tab === "orders") {
      $(".cqr-orders-content").removeClass("d-none");
      this.loadOrders();
    } else if (tab === "notifications") {
      $(".cqr-notifications-content").removeClass("d-none");
      this.loadNotifications();
    }
  };

  // =========================================================================
  // CATEGORIES & ADDRESSES
  // =========================================================================

  loadCategories = () => {
    UtilObject.getCategories((result) => {
      const select = $("#cqrCategorySelect");
      select.find("option:not(:first)").remove();
      if (Array.isArray(result) && result.length > 0) {
        result.forEach((cat) => {
          select.append(
            `<option value="${cat.Picklist_ID}">${cat.Picklist_display_value}</option>`,
          );
        });
      } else {
        console.warn("No categories found");
        select.append("<option value=''>No categories available</option>");
      }
    });
  };

  loadAddresses = () => {
    if (!this.customerId) return;
    UtilObject.getAddresses(this.customerId, (result) => {
      const select = $("#cqrAddressSelect");
      select.find("option:not(:first):not([value='NEW'])").remove();
      if (Array.isArray(result)) {
        result.forEach((addr) => {
          select.append(
            `<option value="${addr.Customer_Address_ID}">${addr.Address_Name} - ${addr.Address_Line_1}</option>`,
          );
        });
      }
    });
  };

  initMapSelection = async () => {
    $("#cqrAddressSelect").val("NEW").trigger("change");

    const modalId = window.$("#locationCall").length ? "locationCall" : 
                   window.$("#locationCallNavTop").length ? "locationCallNavTop" : null;

    if (modalId) {
      const mapContainerId = modalId === "locationCall" ? "map" : "mapAddressForDesktop";
      this.safeHideModal("createQuoteRequestModal");
      this.safeShowModal(modalId);

      window
        .$(`#${modalId}`)
        .off("shown.bs.modal.cqr")
        .on("shown.bs.modal.cqr", () => {
          GoogleMapsApiObject.initModal(mapContainerId).catch((err) => {
            console.error("Map initialization failed:", err);
          });
        });

      $(".submitBtn")
        .off("click.cqr")
        .on("click.cqr", () => {
          const addressData = {
            Customer_ID: this.customerId,
            Address_Name: $(`.inputAddressNameNavTop`).val() || $(".inputAddressName").val() || "Other",
            Address_Line_1: $(`.inputAddressNavTop`).val() || $(".inputAddress").val(),
            Landmark: $(`.inputAddressshortNavTop`).val() || $(".inputLandmark").val(),
            City: $(`.inputCityNavTop`).val() || $(".inputCity").val(),
            State: $(`.inputStateNavTop`).val() || $(".inputState").val(),
            Pincode: $(`.inputPincodeNavTop`).val() || $(".inputPincode").val(),
            lat: $(".inputLat").val(),
            lon: $(".inputLon").val(),
            IsSelected: 1,
          };

          if (!addressData.Address_Name || !addressData.Address_Line_1) {
            alert("Please provide an Address Name and full Address.");
            return;
          }

          if (!this.customerId) {
            // Guest address handling - just populate the field in the quote modal
            $("#cqrLocation").val(addressData.Address_Line_1);
            $("#cqrAddressSelect").val("NEW").trigger("change");
            $("#cqrNewAddressContainer").removeClass("d-none");
            this.safeHideModal(modalId);
            this.safeShowModal("createQuoteRequestModal");
            return;
          }

          $(".submitBtn").prop("disabled", true).text("Saving...");

          $.ajax({
            url: baseURL + "api/customer/Account/AddAddress",
            type: "POST",
            data: addressData,
            headers: { Authorization: X_API_KEY },
            success: (res) => {
              this.showToast("Address saved successfully", "success");
              setTimeout(() => {
                this.loadAddresses();
                this.safeHideModal(modalId);
                this.safeShowModal("createQuoteRequestModal");
                $(".submitBtn").prop("disabled", false).text("Save changes");
              }, 800);
            },
            error: (err) => {
              alert("Failed to save address. Please try again.");
              $(".submitBtn").prop("disabled", false).text("Save changes");
            },
          });
        });

      window
        .$(`#${modalId}`)
        .off("hidden.bs.modal.cqr")
        .one("hidden.bs.modal.cqr", () => {
          if (!window.$("#createQuoteRequestModal").hasClass("show")) {
            this.safeShowModal("createQuoteRequestModal");
          }
        });
    } else {
      alert(
        "Map integration not found in current view. Please type the address.",
      );
    }
  };

  // =========================================================================
  // REQUEST LIFECYCLE
  // =========================================================================

  createQuoteRequest = () => {
    const description = $("#cqrDescription").val().trim();
    const addressId = $("#cqrAddressSelect").val();
    const location = $("#cqrLocation").val();
    const deliveryDate = $("#cqrDeliveryDate").val();

    if (!description || !deliveryDate || (!this.customerId && !location && addressId === "NEW") || (this.customerId && !addressId)) {
      alert("Please fill in all required fields.");
      return;
    }

    if (!this.customerId) {
      // Guest User - Show Informative Modal
      this.safeHideModal("createQuoteRequestModal");
      this.safeShowModal("cqrLoginPromptModal");
      return;
    }

    $(".cqr-submit-request")
      .prop("disabled", true)
      .html(
        '<span class="spinner-border spinner-border-sm"></span> Submitting...',
      );

    const formData = new FormData();
    formData.append("Customer_ID", this.customerId);
    formData.append("category_id", $("#cqrCategorySelect").val());
    formData.append("description", description);
    formData.append("address_id", addressId !== "NEW" ? addressId : "");
    formData.append("location", location);
    formData.append("delivery_date", deliveryDate);
    formData.append("budget_min", $("#cqrBudgetMin").val());
    formData.append("budget_max", $("#cqrBudgetMax").val());

    const imageFile = $("#cqrImage")[0].files[0];
    if (imageFile) {
      formData.append("image", imageFile);
    }

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/create",
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        this.safeHideModal("createQuoteRequestModal");
        $("#cqrCreateForm")[0].reset();
        this.removeImagePreview();
        this.loadMyRequests();
        this.showToast("Quote request created successfully!", "success");

        // Redirect to account servicing page after 1.5 seconds
        setTimeout(() => {
          window.location.href =
            baseURL + "customer/account?section=quote-requests";
        }, 1500);
      },
      error: (xhr) => {
        this.showToast(
          xhr.responseJSON?.message || "Failed to create quote request",
          "error",
        );
      },
      complete: () => {
        $(".cqr-submit-request").prop("disabled", false).html("Submit Request");
      },
    });
  };

  handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert("File is too large. Max size is 5MB.");
        this.removeImagePreview();
        return;
      }
      // Validate file type
      if (!file.type.match("image.*")) {
        alert("Please select an image file (JPG, PNG, WEBP).");
        this.removeImagePreview();
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        $("#cqrImagePreview img").attr("src", event.target.result);
        $("#cqrImagePreview").removeClass("d-none");
        $("#cqrImagePlaceholder").addClass("d-none");
      };
      reader.readAsDataURL(file);
    }
  };

  removeImagePreview = () => {
    $("#cqrImage").val("");
    $("#cqrImagePreview img").attr("src", "");
    $("#cqrImagePreview").addClass("d-none");
    $("#cqrImagePlaceholder").removeClass("d-none");
  };

  loadMyRequests = () => {
    if (!this.customerId) return;
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/myRequests",
      type: "GET",
      data: { Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const requests = result?.data || [];
        const container = $(".cqr-requests-list");
        container.empty();

        if (requests.length === 0) {
          $(".cqr-requests-empty").removeClass("d-none");
          return;
        }

        $(".cqr-requests-empty").addClass("d-none");
        requests.forEach((req) => {
          container.append(this.buildRequestCard(req));
        });

        $(".cqr-view-quotes")
          .off("click")
          .on("click", (e) => {
            const requestId = $(e.currentTarget).data("request-id");
            this.viewQuotes(requestId);
          });

        $(".cqr-cancel-request")
          .off("click")
          .on("click", (e) => {
            const requestId = $(e.currentTarget).data("request-id");
            const desc = $(e.currentTarget).data("desc");
            this.showCancelModal(requestId, desc);
          });
      },
    });
  };

  buildRequestCard = (req) => {
    const statusClass = this.getStatusClass(req.status);
    const timeAgo = this.timeAgo(req.created_at);
    const quoteCount = req.quote_count || 0;
    const categoryName = req.category_name || "General";
    const description =
      req.description.length > 80
        ? req.description.substring(0, 80) + "..."
        : req.description;

    const actionBtn =
      req.status === "OPEN" || req.status === "NEGOTIATING"
        ? `<button class="btn btn-sm text-white cqr-view-quotes" data-request-id="${req.id}" style="background: #ff385c; border-radius: 8px;">View Quotes (${quoteCount}) →</button>`
        : `<span class="text-muted small">${req.status === "CLOSED" ? "Order created" : "Expired"}</span>`;

    return `
      <div class="card mb-3 cqr-request-card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <span class="badge cqr-category-badge">${categoryName}</span>
            <div class="text-end">
              <span class="badge ${statusClass}">${req.status}</span>
              ${
                req.status === "OPEN" || req.status === "NEGOTIATING"
                  ? `<div class="mt-2"><a href="javascript:void(0)" class="cqr-cancel-request" data-request-id="${req.id}" data-desc="${req.description}"><i class="fa fa-times-circle me-1"></i> Cancel Request</a></div>`
                  : ""
              }
            </div>
          </div>
          <p class="mb-2 fw-bold cqr-card-desc">${description}</p>
          <div class="d-flex justify-content-between align-items-center">
            <div class="cqr-card-meta">
              ${req.location ? `<span class="me-3"><i class="fa fa-map-marker-alt me-1"></i>${req.location}</span>` : ""}
              <span class="me-3"><i class="fa fa-clock me-1"></i>${timeAgo}</span>
            </div>
            ${actionBtn}
          </div>
        </div>
      </div>
    `;
  };

  // =========================================================================
  // NEGOTIATION & QUOTES
  // =========================================================================

  viewQuotes = (requestId) => {
    $(".cqr-tab-content").addClass("d-none");
    $(".cqr-quotes-panel").removeClass("d-none").data("request-id", requestId);

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/quotes",
      type: "GET",
      data: { request_id: requestId, Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const quotes = result?.data || [];
        const container = $(".cqr-quotes-list");
        container.empty();

        if (quotes.length === 0) {
          $(".cqr-quotes-empty").removeClass("d-none");
          return;
        }

        $(".cqr-quotes-empty").addClass("d-none");
        quotes.forEach((q) => {
          container.append(this.buildQuoteCard(q));
        });

        // Event bindings for action buttons
        $(".cqr-accept-quote")
          .off("click")
          .on("click", (e) => {
            const negId = $(e.currentTarget).data("neg-id");
            const vendorName = $(e.currentTarget).data("vendor-name");
            const price = $(e.currentTarget).data("price");
            if (!negId) {
              this.showToast(
                "Cannot accept this quote: negotiation record missing.",
                "warning",
              );
              return;
            }
            this.showAcceptModal(negId, vendorName, price);
          });

        $(".cqr-counter-quote")
          .off("click")
          .on("click", (e) => {
            const quoteId = $(e.currentTarget).data("quote-id");
            const vendorName = $(e.currentTarget).data("vendor-name");
            const price = $(e.currentTarget).data("price");
            this.showCounterModal(quoteId, vendorName, price);
          });

        $(".cqr-bind-quote")
          .off("click")
          .on("click", (e) => {
            const quoteId = $(e.currentTarget).data("quote-id");
            const vendorName = $(e.currentTarget).data("vendor-name");
            const price = $(e.currentTarget).data("price");
            const requestId = $(e.currentTarget).data("request-id");
            const serviceDesc = $(e.currentTarget).data("service-desc");
            this.handleBindQuote(
              quoteId,
              vendorName,
              price,
              requestId,
              serviceDesc,
            );
          });

        // History modal trigger (using event delegation for robustness)
        $(document)
          .off("click", ".cqr-view-history")
          .on("click", ".cqr-view-history", (e) => {
            const quoteId = $(e.currentTarget).data("quote-id");
            this.showHistoryModal(quoteId);
          });
      },
    });
  };

  buildQuoteCard = (q) => {
    const displayStatus = q.negotiation_status || q.status || "PENDING";
    const statusClass = this.getQuoteStatusClass(displayStatus);
    const vendorName = q.Business_Name || "Unknown Vendor";
    const rating = q.Vendor_Rating > 0 ? q.Vendor_Rating : "New";
    const isCustomerTurn = q.sender_type === "VENDOR";
    const isAccepted = displayStatus === "ACCEPTED";

    let actionButtons = "";
    if (displayStatus === "PENDING") {
      if (isCustomerTurn) {
        actionButtons = `
          <div class="row g-2 mt-2">
            <div class="col-6">
              <button class="btn btn-sm btn-outline-primary w-100 cqr-counter-quote" 
                data-quote-id="${q.id}" data-vendor-name="${vendorName}" data-price="${q.current_price}">Counter</button>
            </div>
            <div class="col-6">
              <button class="btn btn-sm text-white w-100 cqr-accept-quote" style="background: #28a745;"
                data-neg-id="${q.latest_neg_id}" data-vendor-name="${vendorName}" data-price="${q.current_price}">Accept</button>
            </div>
          </div>`;
      } else {
        actionButtons = `<div class="mt-2 text-center small text-muted font-italic"><i class="fa fa-hourglass-half me-1"></i>Waiting for Vendor...</div>`;
      }
    } else if (isAccepted) {
      actionButtons = `
        <button class="btn btn-sm text-white w-100 mt-2 cqr-bind-quote" style="background: #ff385c;"
          data-quote-id="${q.id}" data-vendor-name="${vendorName}" data-price="${q.current_price}"
          data-request-id="${q.quote_request_id}" data-service-desc="${q.request_description || ""}">
          Select Vendor & Confirm Order
        </button>`;
    }

    return `
      <div class="card mb-3 cqr-quote-card border-0 shadow-sm" style="border-radius: 12px;">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="d-flex align-items-center">
              <img src="${getVendorBusinessImageUrl(q.vendor_image)}" class="rounded-circle me-2" width="40" height="40" style="object-fit: cover;">
              <div>
                <h6 class="mb-0 fw-bold">${vendorName}</h6>
                <span class="badge bg-light text-success small p-1 px-2 border">${rating} <i class="fa fa-star text-warning" style="font-size: 0.7rem;"></i></span>
              </div>
            </div>
            <span class="badge ${statusClass}">${displayStatus}</span>
          </div>
          
          <div class="bg-light rounded p-2 mb-2 d-flex justify-content-between align-items-center">
             <div class="small text-muted">Current Price</div>
             <div class="h5 mb-0 fw-bold text-primary">₹${parseFloat(q.current_price).toLocaleString("en-IN")}</div>
          </div>

          ${q.last_message ? `<div class="p-2 border-start border-4 border-info bg-light small mb-2 font-italic">"${q.last_message}"</div>` : ""}
          
          <div class="d-flex justify-content-between align-items-center mt-3">
            <a href="javascript:void(0)" class="small cqr-view-history fw-bold" data-quote-id="${q.id}">View History</a>
            <span class="text-muted small">${this.timeAgo(q.created_at)}</span>
          </div>
          ${actionButtons}
        </div>
      </div>`;
  };

  showAcceptModal = (negId, vendorName, price) => {
    $("#acceptQuoteId").val(negId);
    $(".accept-vendor-name").text(vendorName);
    $(".accept-quote-price").text(parseFloat(price).toLocaleString("en-IN"));
    this.safeShowModal("acceptQuoteModal");

    $(".cqr-confirm-accept")
      .off("click")
      .on("click", () => this.handleAcceptOffer(negId));
  };

  handleAcceptOffer = (negId) => {
    const btn = $(".cqr-confirm-accept");
    btn
      .prop("disabled", true)
      .html('<span class="spinner-border spinner-border-sm"></span>');

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/acceptOffer",
      type: "POST",
      data: { negotiation_id: negId, Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: () => {
        this.safeHideModal("acceptQuoteModal");
        this.showToast(
          "Offer accepted! You can now bind the quote.",
          "success",
        );
        this.viewQuotes($(".cqr-quotes-panel").data("request-id"));
      },
      error: () => this.showToast("Failed to accept offer.", "error"),
      complete: () => btn.prop("disabled", false).text("Confirm Accept"),
    });
  };

  showCounterModal = (quoteId, vendorName, lastPrice) => {
    $("#counterQuoteId").val(quoteId);
    $(".counter-vendor-name").text(vendorName);
    $(".counter-last-price").text(
      parseFloat(lastPrice).toLocaleString("en-IN"),
    );
    $("#cqrCounterPrice").val("");
    $("#cqrCounterMessage").val("");
    this.safeShowModal("counterQuoteModal");

    $(".cqr-confirm-counter")
      .off("click")
      .on("click", () => this.submitCounterOffer());
  };

  submitCounterOffer = () => {
    const quoteId = $("#counterQuoteId").val();
    const price = $("#cqrCounterPrice").val();
    const message = $("#cqrCounterMessage").val();

    if (!price || price <= 0) {
      alert("Please enter a valid counter price.");
      return;
    }

    const btn = $(".cqr-confirm-counter");
    btn.prop("disabled", true).text("Sending...");

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/counter",
      type: "POST",
      data: {
        quote_id: quoteId,
        Customer_ID: this.customerId,
        price: price,
        message: message,
      },
      headers: { Authorization: X_API_KEY },
      success: () => {
        this.safeHideModal("counterQuoteModal");
        this.showToast("Counter offer sent successfully!", "success");
        this.viewQuotes($(".cqr-quotes-panel").data("request-id"));
      },
      error: () => this.showToast("Failed to send counter offer.", "error"),
      complete: () => btn.prop("disabled", false).text("Send Counter Offer"),
    });
  };

  handleBindQuote = (
    quoteId,
    vendorName,
    price,
    requestId,
    serviceDesc = "",
  ) => {
    // Populate Bind Modal
    $(".bind-vendor-name").text(vendorName);
    $(".bind-quote-price").text(parseFloat(price).toLocaleString("en-IN"));
    $(".bind-service-desc").text(serviceDesc || "Project Service");
    $("#bindQuoteId").val(quoteId);
    $("#bindRequestId").val(requestId);

    this.safeShowModal("bindQuoteModal");
  };

  confirmBindQuote = () => {
    const quoteId = $("#bindQuoteId").val();
    const requestId = $("#bindRequestId").val();
    const btn = $(".cqr-confirm-bind");

    if (!quoteId) return;

    btn
      .prop("disabled", true)
      .html(
        '<span class="spinner-border spinner-border-sm me-1"></span> Binding...',
      );
    this.showToast("Binding vendor to project...", "info");

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/bind",
      type: "POST",
      data: { quote_id: quoteId, Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: () => {
        this.safeHideModal("bindQuoteModal");
        this.showToast("Project bound successfully!", "success");
        setTimeout(() => window.location.reload(), 1500);
      },
      error: (err) => {
        this.showToast(
          "Failed to bind quote. " + (err.responseJSON?.message || ""),
          "error",
        );
        btn.prop("disabled", false).text("Confirm & Bind");
      },
      complete: () => {
        // Reset button state if not reloading
        setTimeout(
          () => btn.prop("disabled", false).text("Confirm & Bind"),
          2000,
        );
      },
    });
  };

  // =========================================================================
  // ORDERS & ITEMIZATION
  // =========================================================================

  loadOrders = () => {
    if (!this.customerId) return;
    const container = $(".cqr-orders-list");
    container.html(
      '<div class="text-center py-5"><div class="spinner-border text-primary"></div></div>',
    );

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/orders",
      type: "GET",
      data: { Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        const orders = res?.data || [];
        // console.log("Loaded orders:", orders);
        container.empty();
        if (orders.length === 0) {
          $(".cqr-orders-empty").removeClass("d-none");
          return;
        }
        $(".cqr-orders-empty").addClass("d-none");
        orders.forEach((order) => {
          container.append(this.buildOrderCard(order));
        });
      },
      error: () =>
        container.html(
          '<p class="text-center text-danger py-5">Failed to load orders.</p>',
        ),
    });
  };

  buildOrderCard = (order) => {
    return `
      <div class="card mb-3 border-0 shadow-sm" style="border-radius: 15px; overflow: hidden;">
        <div class="card-body p-3">
          <div class="d-flex align-items-center mb-3">
            <div class="flex-shrink-0">
              <img src="${getVendorBusinessImageUrl(order.vendor_image)}" alt="Vendor Image"
                   class="rounded-circle" style="width: 50px; height: 50px; object-fit: cover;">
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="mb-0 fw-bold">${order.Business_Name || "Vendor"}</h6>
              <div class="small text-muted">Order #${order.Order_No}</div>
            </div>
            <div class="text-end">
              <span class="badge ${this.getStatusClass(order.Order_Status)}">${order.Order_Status}</span>
            </div>
          </div>
          
          <div class="bg-light p-2 rounded mb-3">
            <div class="d-flex justify-content-between small mb-1">
              <span>Final Price:</span>
              <strong class="text-primary">₹${parseFloat(order.final_price).toLocaleString("en-IN")}</strong>
            </div>
            <div class="d-flex justify-content-between small">
              <span>Location:</span>
              <span class="text-muted text-truncate ms-2" style="max-width: 150px;">${order.Customer_Address_Details || "No address"}</span>
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2">
            <button class="btn btn-primary btn-sm flex-grow-1 rounded-pill py-2" 
                    onclick="window.customerQuoteRequestsObj.showOrderBreakdown('${order.Order_ID}')">
              <i class="fa fa-list-ul me-1"></i> View Breakdown
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-pill py-2 cqr-view-history" data-quote-id="${order.negotiation_id || ""}">
              <i class="fa fa-history me-1"></i> History
            </button>
            <button class="btn btn-outline-secondary btn-sm rounded-pill py-2" onclick="window.location.hash='#chat/${order.Vendor_ID}'">
              <i class="fa fa-comment"></i>
            </button>
          </div>
        </div>
      </div>`;
  };

  showOrderBreakdown = (orderId) => {
    this.safeShowModal("viewItemizationModal");
    const body = $("#cqrItemizationBody");
    const totalSpan = $("#cqrItemizationTotal");

    body.html(
      '<tr><td colspan="3" class="text-center py-3"><div class="spinner-border spinner-border-sm text-primary"></div></td></tr>',
    );
    totalSpan.text("...");

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/orderDetails",
      type: "GET",
      data: { order_id: orderId, Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        const items = res?.data?.items || [];
        const order = res?.data?.order;
        body.empty();

        if (items.length === 0) {
          body.append(
            '<tr><td colspan="3" class="text-center text-muted py-3">No breakdown provided by vendor yet.</td></tr>',
          );
          totalSpan.text(
            order ? parseFloat(order.final_price).toLocaleString("en-IN") : "0",
          );
          return;
        }

        items.forEach((item) => {
          body.append(`
            <tr>
              <td class="ps-3">
                <div class="fw-bold small">${item.custom_name || "Service Item"}</div>
                ${item.custom_description ? `<div class="text-muted extra-small" style="font-size: 0.7rem;">${item.custom_description}</div>` : ""}
              </td>
              <td class="text-center small">${item.Quantity}</td>
              <td class="text-end pe-3 small">₹${parseFloat(item.Price).toLocaleString("en-IN")}</td>
            </tr>
          `);
        });
        totalSpan.text(parseFloat(order.final_price).toLocaleString("en-IN"));
      },
      error: () =>
        body.html(
          '<tr><td colspan="3" class="text-center text-danger py-3">Failed to load breakdown.</td></tr>',
        ),
    });
  };

  showHistoryModal = (quoteId) => {
    this.safeShowModal("negotiationHistoryModal");
    const container = $(".cqr-history-list");
    container.html(
      '<div class="text-center py-3"><div class="spinner-border spinner-border-sm"></div></div>',
    );

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/negotiations",
      type: "GET",
      data: {
        quote_id: quoteId,
        Customer_ID: this.customerId, // Ensure authorize() works
      },
      headers: { Authorization: X_API_KEY },
      success: (res) => {
        const history = res?.data || [];
        container.empty();
        if (history.length === 0) {
          container.html(
            '<p class="text-center text-muted">No history found.</p>',
          );
          return;
        }
        history.forEach((h) => {
          const isCustomer = h.sender_type === "CUSTOMER";
          container.append(`
            <div class="mb-3 d-flex flex-column ${isCustomer ? "ms-auto text-end" : "me-auto"}" style="max-width: 80%;">
              <div class="small fw-bold mb-1">${isCustomer ? "You" : "Vendor"}</div>
              <div class="p-2 rounded ${isCustomer ? "bg-primary text-white" : "bg-light"}">
                <div class="fw-bold mb-1">₹${parseFloat(h.price).toLocaleString("en-IN")}</div>
                ${h.message ? `<div class="small">${h.message}</div>` : ""}
              </div>
              <div class="text-muted" style="font-size: 0.7rem;">${this.timeAgo(h.created_at)}</div>
            </div>`);
        });
      },
      error: () =>
        container.html(
          '<p class="text-center text-danger">Failed to load history.</p>',
        ),
    });
  };

  showCancelModal = (requestId, desc) => {
    $("#cancelRequestId").val(requestId);
    $(".cancel-request-desc").text(desc);
    this.safeShowModal("cancelRequestModal");

    $(".cqr-confirm-cancel")
      .off("click")
      .on("click", () => this.handleCancelRequest(requestId));
  };

  handleCancelRequest = (requestId) => {
    const btn = $(".cqr-confirm-cancel");
    btn.prop("disabled", true).text("Cancelling...");

    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/cancelRequest",
      type: "POST",
      data: { request_id: requestId, Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        this.safeHideModal("cancelRequestModal");
        this.showToast("Request cancelled successfully.", "success");
        this.loadMyRequests();
      },
      error: (xhr) => {
        this.showToast(
          xhr.responseJSON?.message || "Failed to cancel request.",
          "error",
        );
      },
      complete: () => {
        btn.prop("disabled", false).text("Cancel Request");
      },
    });
  };

  // =========================================================================
  // NOTIFICATIONS & HELPERS
  // =========================================================================

  showRequestsList = () => {
    $(".cqr-quotes-panel").addClass("d-none");
    $(".cqr-requests-content").removeClass("d-none");
  };

  loadNotificationBadge = () => {
    if (!this.customerId) return;
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/notifications",
      type: "GET",
      data: { Customer_ID: this.customerId, limit: 1 },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const unread = result?.data?.unread_count || 0;
        if (unread > 0) {
          $(".cqr-notif-badge").text(unread).removeClass("d-none");
        } else {
          $(".cqr-notif-badge").addClass("d-none");
        }
      },
    });
  };

  loadNotifications = () => {
    if (!this.customerId) return;
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/notifications",
      type: "GET",
      data: { Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        const notifications = result?.data?.notifications || [];
        const container = $(".cqr-notifications-list");
        container.empty();
        if (notifications.length === 0) {
          container.html(
            '<p class="text-center text-muted py-3">No notifications</p>',
          );
          return;
        }
        notifications.forEach((n) => {
          container.append(`
            <div class="card mb-2 cqr-notif-card ${n.is_read == 1 ? "cqr-notif-read" : "cqr-notif-unread"}">
              <div class="card-body py-2 px-3">
                <div class="d-flex justify-content-between">
                  <strong class="small">${n.title}</strong>
                  <small class="text-muted">${this.timeAgo(n.created_at)}</small>
                </div>
                <p class="mb-0 small text-muted">${n.message || ""}</p>
              </div>
            </div>`);
        });
      },
    });
  };

  markAllNotificationsRead = () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/markNotificationRead",
      type: "POST",
      data: { notification_id: "all", Customer_ID: this.customerId },
      headers: { Authorization: X_API_KEY },
      success: () => {
        $(".cqr-notif-badge").addClass("d-none");
        this.loadNotifications();
      },
    });
  };

  getStatusClass = (status) => {
    switch (status) {
      case "OPEN":
        return "bg-success";
      case "NEGOTIATING":
        return "bg-info";
      case "CLOSED":
        return "bg-secondary";
      case "CANCELLED":
        return "bg-danger";
      case "EXPIRED":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  getQuoteStatusClass = (status) => {
    switch (status) {
      case "PENDING":
        return "bg-warning text-dark";
      case "ACCEPTED":
        return "bg-success";
      case "REJECTED":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  timeAgo = (dateStr) => {
    if (!dateStr) return "";
    const now = new Date();
    const date = new Date(dateStr);
    const seconds = Math.floor((now - date) / 1000);
    if (seconds < 60) return "just now";
    if (seconds < 3600) return Math.floor(seconds / 60) + "m ago";
    if (seconds < 86400) return Math.floor(seconds / 3600) + "h ago";
    if (seconds < 604800) return Math.floor(seconds / 86400) + "d ago";
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  };

  showToast = (message, type = "success") => {
    const bg = type === "success" ? "#28a745" : "#dc3545";
    const toast = $(
      `<div class="cqr-toast" style="background: ${bg};">${message}</div>`,
    );
    $("body").append(toast);
    setTimeout(() => toast.addClass("show"), 10);
    setTimeout(() => {
      toast.removeClass("show");
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  };

  // =========================================================================
  // GUEST FLOW HELPERS
  // =========================================================================

  checkPendingQuote = () => {
    const rawData = sessionStorage.getItem("PENDING_QUOTE_DATA");
    if (!rawData) return;

    if (!this.customerId) {
      // Still a guest, maybe they cancelled login. Carry on.
      return;
    }

    // User is logged in and has pending data
    try {
      const data = JSON.parse(rawData);

      // Open the modal after a short delay to ensure everything is initialized
      setTimeout(() => {
        this.safeShowModal("createQuoteRequestModal");
        
        // Populate after a tiny extra delay to ensure the modal is in DOM correctly
        setTimeout(() => {
          this.populateQuoteForm(data);
          // Only remove once we've successfully shown and populated it
          sessionStorage.removeItem("PENDING_QUOTE_DATA");
        }, 100);
      }, 1000);
    } catch (e) {
      console.error("Failed to parse pending quote data", e);
      sessionStorage.removeItem("PENDING_QUOTE_DATA");
    }
  };

  populateQuoteForm = (data) => {
    $("#cqrCategorySelect").val(data.category_id);
    $("#cqrDescription").val(data.description);
    $("#cqrDeliveryDate").val(data.delivery_date);
    $("#cqrBudgetMin").val(data.budget_min);
    $("#cqrBudgetMax").val(data.budget_max);

    if (data.location) {
      $("#cqrLocation").val(data.location);
      $("#cqrAddressSelect").val("NEW").trigger("change");
    }
  };

  redirectToLoginAfterSavingData = () => {
    const pendingData = {
      category_id: $("#cqrCategorySelect").val(),
      description: $("#cqrDescription").val().trim(),
      address_id: null,
      location: $("#cqrLocation").val(),
      delivery_date: $("#cqrDeliveryDate").val(),
      budget_min: $("#cqrBudgetMin").val(),
      budget_max: $("#cqrBudgetMax").val(),
    };

    sessionStorage.setItem("PENDING_QUOTE_DATA", JSON.stringify(pendingData));
    UtilObject.setRedirectAfterLogin(window.location.href);

    $(".cqr-guest-login-confirm").prop("disabled", true).text("Redirecting...");

    setTimeout(() => {
      window.location.href = baseURL + "customer/login";
    }, 500);
  };

  // =========================================================================
  // MODAL UTILITIES
  // =========================================================================

  safeShowModal = (modalId) => {
    const el = document.getElementById(modalId);
    if (!el) {
      console.error(`[CQR] Modal element #${modalId} not found in DOM!`);
      return;
    }

    // Ensure page container is not hidden (if on the dedicated CQR page)
    if ($(".customerQuoteRequestsPage").length) {
      $(".customerQuoteRequestsPage").removeClass("d-none");
    }

    try {
      if (window.$ && typeof window.$.fn.modal === "function") {
        const $el = window.$(el);
        $el.modal("show");
        
        // Force body class if needed (Bootstrap sometimes misses it on quick transitions)
        setTimeout(() => {
          if ($(".modal.show").length > 0 && !$("body").hasClass("modal-open")) {
            $("body").addClass("modal-open").css("overflow", "hidden");
          }
        }, 300);
      } else if (window.bootstrap && window.bootstrap.Modal) {
        const m = new window.bootstrap.Modal(el);
        m.show();
      } else {
        console.error("[CQR] No modal manager (jQuery or Bootstrap) found!");
      }
    } catch (e) {
      console.error(`[CQR] Exception showing modal #${modalId}:`, e);
    }
  };

  safeHideModal = (modalId) => {
    const el = document.getElementById(modalId);
    if (!el) return;

    try {
      if (window.$ && typeof window.$.fn.modal === "function") {
        window.$(el).modal("hide");
      } else if (window.bootstrap && window.bootstrap.Modal) {
        const m = window.bootstrap.Modal.getInstance(el);
        if (m) m.hide();
      }
    } catch (e) {
      console.error(`[CQR] Exception hiding modal #${modalId}:`, e);
    }
  };
}

